export const translations = {
  de: {
    nav: {
      home: "Startseite",
      services: "Dienstleistungen",
      references: "Referenzen",
      about: "Über uns",
      contact: "Kontakt",
      callNow: "Jetzt anrufen",
      emailQuote: "E-Mail Offerte",
    },
    emergency: {
      label: "Pikett 24/7",
      text: "Notfall? Wir sind rund um die Uhr für Sie da",
      cta: "+41 78 256 45 99",
    },
    home: {
      heroEyebrow: "Sanitär · Heizung · Lüftung",
      heroTitle: "Ihre Haustechnik. Unsere Leidenschaft.",
      heroSubtitle: "Hochwertige Sanitär-, Heizungs- und Umbau-Dienstleistungen in der Region Basel. Zuverlässig. Pünktlich. Präzise.",
      heroCta1: "Offerte anfordern",
      heroCta2: "Dienstleistungen ansehen",
      heroBadge: "GmbH · Allschwil",
      servicesTitle: "Was wir für Sie tun",
      servicesSubtitle: "Vier Kernbereiche – ein verlässlicher Partner.",
      servicesLearnMore: "Mehr erfahren",
      statsTitle: "Zahlen, die Vertrauen schaffen",
      statYears: "Jahre Erfahrung",
      statProjects: "Abgeschlossene Projekte",
      statSatisfaction: "Kundenzufriedenheit",
      statResponse: "Stunden Notdienst",
      whyTitle: "Warum SHK Haustechnik?",
      why1Title: "Schweizer Qualität",
      why1Text: "Präzise Handwerksarbeit nach höchsten Standards – nichts weniger.",
      why2Title: "Pikett 24/7",
      why2Text: "Wasserrohrbruch, Heizungsausfall? Wir sind sofort zur Stelle.",
      why3Title: "Faire Preise",
      why3Text: "Transparente Offerten ohne versteckte Kosten – garantiert.",
      why4Title: "Regional verwurzelt",
      why4Text: "Seit Jahren der Partner für Basel und Umgebung.",
      testimonialsTitle: "Was unsere Kunden sagen",
      ctaTitle: "Bereit für Ihr Projekt?",
      ctaSubtitle: "Lassen Sie uns gemeinsam Ihre Vision realisieren. Wir beraten Sie gerne unverbindlich.",
      ctaButton: "Kostenlose Beratung",
    },
    services: {
      title: "Unsere Dienstleistungen",
      subtitle: "Vom kleinen Reparaturauftrag bis zum kompletten Umbau – wir liefern alles aus einer Hand.",
      sanitaer: {
        name: "Sanitär",
        short: "Installation, Wartung & Reparatur",
        long: "Von der Toiletten-Reparatur bis zur kompletten Badezimmer-Installation. Wir arbeiten präzise, sauber und nach modernsten Standards. Für Wohn- und Gewerbeobjekte.",
        benefits: ["Schnelle Reparaturen", "Komplett-Installationen", "Wartungsservice", "24/7 Notdienst"],
        process: ["Beratung & Aufmass", "Transparente Offerte", "Pünktliche Ausführung", "Endkontrolle & Garantie"],
      },
      heizung: {
        name: "Heizungsservice",
        short: "Heizsysteme installieren, warten & optimieren",
        long: "Neue Heizsysteme, regelmässige Wartung, Optimierungen für mehr Effizienz und schnelle Reparaturen. Wir kennen Wärmepumpen, Gas-, Öl- und Pellet-Heizungen.",
        benefits: ["Wärmepumpen-Spezialisten", "Energieeffizienz-Beratung", "Wartung & Service", "Schnelle Reparaturen"],
        process: ["Energie-Analyse", "Systemauswahl", "Professionelle Installation", "Jährliche Wartung"],
      },
      sanierung: {
        name: "Sanierung",
        short: "Schäden beheben, modernisieren, restaurieren",
        long: "Wasserschäden, Feuerschäden, Schimmelsanierung. Badezimmer- und Küchen-Renovierung. Wir sanieren modern, nachhaltig und werterhaltend.",
        benefits: ["Wasser- & Feuerschadensanierung", "Schimmelentfernung", "Bad- & Küchenrenovierung", "Modernisierung Elektrik/Sanitär"],
        process: ["Schadensanalyse", "Sanierungskonzept", "Koordinierte Umsetzung", "Qualitätskontrolle"],
      },
      umbau: {
        name: "Umbau",
        short: "Räume neu denken & umsetzen",
        long: "Küchen, Bäder, Wohnräume oder Büros – wir gestalten Ihre Räume um. Mit erfahrenen Partnern und perfekter Koordination aller Gewerke.",
        benefits: ["Komplettumbau", "Bad- & Küchenumbau", "Büro-Umbauten", "Projektkoordination"],
        process: ["Konzeption & Planung", "Bewilligungen", "Ausführung aller Gewerke", "Übergabe & Nachbetreuung"],
      },
      ctaQuote: "Kostenlose Beratung anfordern",
      ctaAppointment: "Termin vereinbaren",
      benefitsTitle: "Ihre Vorteile",
      processTitle: "Unser Prozess",
      allServicesTitle: "Weitere Dienstleistungen",
    },
    references: {
      title: "Unsere Referenzen",
      subtitle: "Eine Auswahl unserer abgeschlossenen Projekte aus der Region Basel.",
      all: "Alle",
      noResults: "Keine Referenzen in dieser Kategorie.",
    },
    about: {
      title: "Über SHK Haustechnik GmbH",
      subtitle: "Ihr Partner für moderne Haustechnik in Allschwil",
      story: "Geschichte",
      storyText: "SHK Haustechnik GmbH wurde mit einer klaren Vision gegründet: Hochwertige Sanitär-, Heizungs- und Lüftungs-Dienstleistungen für die Region Basel anzubieten – ehrlich, präzise und zuverlässig. Was klein begann, ist heute ein vertrauenswürdiger Partner für Hausbesitzer, Unternehmen und Immobilienverwaltungen.",
      values: "Werte",
      value1Title: "Qualität",
      value1Text: "Wir geben uns nicht mit weniger zufrieden als mit Schweizer Präzision.",
      value2Title: "Zuverlässigkeit",
      value2Text: "Termine halten wir ein. Versprechen auch. Pikett 24/7 inklusive.",
      value3Title: "Kundenzufriedenheit",
      value3Text: "Sie sind erst zufrieden, wenn wir es auch sind. Punkt.",
      team: "Geschäftsführung",
      founderName: "Elvis Pashaj",
      founderRole: "Geschäftsführer & Gründer",
      founderBio: "Mit langjähriger Erfahrung im SHK-Bereich führt Elvis Pashaj das Unternehmen mit Leidenschaft und höchstem Qualitätsanspruch.",
    },
    contact: {
      title: "Kontakt",
      subtitle: "Wir freuen uns auf Ihre Anfrage. Antwort innerhalb von 24 Stunden.",
      formTitle: "Schreiben Sie uns",
      firstName: "Vorname",
      lastName: "Nachname",
      email: "E-Mail",
      phone: "Telefonnummer",
      service: "Dienstleistung (optional)",
      selectService: "Bitte wählen",
      message: "Ihre Nachricht",
      messagePlaceholder: "Beschreiben Sie kurz Ihr Anliegen…",
      submit: "Nachricht senden",
      submitting: "Wird gesendet…",
      success: "Anfrage erfolgreich gesendet!",
      successDetail: "Wir melden uns innerhalb von 24 Stunden bei Ihnen.",
      error: "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
      infoTitle: "Kontaktinformationen",
      address: "Adresse",
      addressText: "Weiherweg 14\n4123 Allschwil",
      hours: "Öffnungszeiten",
      hoursText: "Mo–Fr: 07:30 – 17:30\nSa: Auf Anfrage\nPikett 24/7",
      whatsappCta: "WhatsApp Nachricht",
      callCta: "Jetzt anrufen",
    },
    footer: {
      tagline: "Ihre Haustechnik. Unsere Leidenschaft.",
      quickLinks: "Schnellzugriff",
      ourServices: "Unsere Dienstleistungen",
      contactInfo: "Kontakt",
      newsletter: "Newsletter",
      newsletterText: "Bleiben Sie informiert über Aktionen und Tipps.",
      rights: "Alle Rechte vorbehalten.",
      imprint: "Impressum",
      privacy: "Datenschutz",
      pikett: "24/7 Pikett-Service",
    },
    whatsapp: {
      message: "Guten Tag, ich interessiere mich für Ihre Dienstleistungen.",
    },
  },
  en: {
    nav: {
      home: "Home",
      services: "Services",
      references: "References",
      about: "About",
      contact: "Contact",
      callNow: "Call now",
      emailQuote: "Email quote",
    },
    emergency: {
      label: "24/7 Emergency",
      text: "Need help now? We're here around the clock",
      cta: "+41 78 256 45 99",
    },
    home: {
      heroEyebrow: "Plumbing · Heating · Ventilation",
      heroTitle: "Your home systems. Our passion.",
      heroSubtitle: "Premium plumbing, heating, and renovation services in the Basel region. Reliable. On time. Precise.",
      heroCta1: "Request a quote",
      heroCta2: "View services",
      heroBadge: "GmbH · Allschwil",
      servicesTitle: "What we do for you",
      servicesSubtitle: "Four core areas – one trustworthy partner.",
      servicesLearnMore: "Learn more",
      statsTitle: "Numbers that build trust",
      statYears: "Years of experience",
      statProjects: "Completed projects",
      statSatisfaction: "Customer satisfaction",
      statResponse: "Emergency hours",
      whyTitle: "Why SHK Haustechnik?",
      why1Title: "Swiss quality",
      why1Text: "Precise craftsmanship to the highest standards – nothing less.",
      why2Title: "24/7 emergency",
      why2Text: "Burst pipe, heating failure? We're on the way immediately.",
      why3Title: "Fair pricing",
      why3Text: "Transparent quotes without hidden costs – guaranteed.",
      why4Title: "Local roots",
      why4Text: "For years the trusted partner for Basel and surroundings.",
      testimonialsTitle: "What our customers say",
      ctaTitle: "Ready for your project?",
      ctaSubtitle: "Let's turn your vision into reality. We'll happily advise you without obligation.",
      ctaButton: "Free consultation",
    },
    services: {
      title: "Our services",
      subtitle: "From small repairs to complete renovations – everything from a single source.",
      sanitaer: {
        name: "Plumbing",
        short: "Installation, maintenance & repair",
        long: "From toilet repairs to complete bathroom installations. We work precisely, cleanly, and to the latest standards. For residential and commercial properties.",
        benefits: ["Fast repairs", "Complete installations", "Maintenance service", "24/7 emergency"],
        process: ["Consultation & measurement", "Transparent quote", "Punctual execution", "Final inspection & warranty"],
      },
      heizung: {
        name: "Heating service",
        short: "Install, maintain & optimise heating systems",
        long: "New heating systems, regular maintenance, efficiency optimisation, and fast repairs. We are experts in heat pumps, gas, oil, and pellet heating.",
        benefits: ["Heat pump specialists", "Energy efficiency advice", "Maintenance & service", "Fast repairs"],
        process: ["Energy analysis", "System selection", "Professional installation", "Annual maintenance"],
      },
      sanierung: {
        name: "Renovation",
        short: "Fix damage, modernise, restore",
        long: "Water damage, fire damage, mould remediation. Bathroom and kitchen renovations. We renovate modern, sustainable, and value-preserving.",
        benefits: ["Water & fire damage repair", "Mould removal", "Bathroom & kitchen renovation", "Modernisation of electrics/plumbing"],
        process: ["Damage analysis", "Renovation concept", "Coordinated execution", "Quality control"],
      },
      umbau: {
        name: "Remodeling",
        short: "Rethink and rebuild your spaces",
        long: "Kitchens, bathrooms, living spaces, or offices – we redesign your spaces. With experienced partners and perfect coordination of all trades.",
        benefits: ["Complete remodels", "Bath & kitchen remodels", "Office remodels", "Project coordination"],
        process: ["Concept & planning", "Permits", "Execution of all trades", "Handover & follow-up"],
      },
      ctaQuote: "Request a free consultation",
      ctaAppointment: "Book an appointment",
      benefitsTitle: "Your benefits",
      processTitle: "Our process",
      allServicesTitle: "More services",
    },
    references: {
      title: "Our references",
      subtitle: "A selection of our completed projects in the Basel region.",
      all: "All",
      noResults: "No references in this category.",
    },
    about: {
      title: "About SHK Haustechnik GmbH",
      subtitle: "Your partner for modern home systems in Allschwil",
      story: "Story",
      storyText: "SHK Haustechnik GmbH was founded with a clear vision: to offer high-quality plumbing, heating, and ventilation services for the Basel region – honest, precise, and reliable. What started small is today a trusted partner for homeowners, businesses, and property managers.",
      values: "Values",
      value1Title: "Quality",
      value1Text: "We don't settle for less than Swiss precision.",
      value2Title: "Reliability",
      value2Text: "We keep appointments. And promises. 24/7 emergency included.",
      value3Title: "Customer satisfaction",
      value3Text: "You're only satisfied when we are. Period.",
      team: "Management",
      founderName: "Elvis Pashaj",
      founderRole: "Managing Director & Founder",
      founderBio: "With many years of experience in the SHK field, Elvis Pashaj leads the company with passion and the highest quality standards.",
    },
    contact: {
      title: "Contact",
      subtitle: "We look forward to your enquiry. Reply within 24 hours.",
      formTitle: "Write to us",
      firstName: "First name",
      lastName: "Last name",
      email: "Email",
      phone: "Phone number",
      service: "Service (optional)",
      selectService: "Please choose",
      message: "Your message",
      messagePlaceholder: "Briefly describe your concern…",
      submit: "Send message",
      submitting: "Sending…",
      success: "Request successfully sent!",
      successDetail: "We'll get back to you within 24 hours.",
      error: "An error occurred. Please try again.",
      infoTitle: "Contact information",
      address: "Address",
      addressText: "Weiherweg 14\n4123 Allschwil",
      hours: "Opening hours",
      hoursText: "Mon–Fri: 07:30 – 17:30\nSat: On request\n24/7 emergency",
      whatsappCta: "WhatsApp message",
      callCta: "Call now",
    },
    footer: {
      tagline: "Your home systems. Our passion.",
      quickLinks: "Quick links",
      ourServices: "Our services",
      contactInfo: "Contact",
      newsletter: "Newsletter",
      newsletterText: "Stay informed about offers and tips.",
      rights: "All rights reserved.",
      imprint: "Imprint",
      privacy: "Privacy",
      pikett: "24/7 Emergency service",
    },
    whatsapp: {
      message: "Hello, I'm interested in your services.",
    },
  },
  fr: {
    nav: {
      home: "Accueil",
      services: "Services",
      references: "Références",
      about: "À propos",
      contact: "Contact",
      callNow: "Appeler",
      emailQuote: "Devis par e-mail",
    },
    emergency: {
      label: "Piquet 24/7",
      text: "Urgence ? Nous sommes là à toute heure",
      cta: "+41 78 256 45 99",
    },
    home: {
      heroEyebrow: "Sanitaire · Chauffage · Ventilation",
      heroTitle: "Votre technique du bâtiment. Notre passion.",
      heroSubtitle: "Services sanitaires, chauffage et rénovation de qualité supérieure dans la région de Bâle. Fiable. Ponctuel. Précis.",
      heroCta1: "Demander un devis",
      heroCta2: "Voir les services",
      heroBadge: "GmbH · Allschwil",
      servicesTitle: "Ce que nous faisons pour vous",
      servicesSubtitle: "Quatre domaines clés – un partenaire de confiance.",
      servicesLearnMore: "En savoir plus",
      statsTitle: "Des chiffres qui inspirent confiance",
      statYears: "Années d'expérience",
      statProjects: "Projets réalisés",
      statSatisfaction: "Satisfaction client",
      statResponse: "Heures d'urgence",
      whyTitle: "Pourquoi SHK Haustechnik ?",
      why1Title: "Qualité suisse",
      why1Text: "Un artisanat précis aux normes les plus élevées – rien de moins.",
      why2Title: "Piquet 24/7",
      why2Text: "Tuyau cassé, panne de chauffage ? Nous arrivons sur le champ.",
      why3Title: "Prix justes",
      why3Text: "Devis transparents sans coûts cachés – garanti.",
      why4Title: "Ancré localement",
      why4Text: "Depuis des années le partenaire de Bâle et environs.",
      testimonialsTitle: "Ce que disent nos clients",
      ctaTitle: "Prêt pour votre projet ?",
      ctaSubtitle: "Réalisons ensemble votre vision. Conseil sans engagement.",
      ctaButton: "Consultation gratuite",
    },
    services: {
      title: "Nos services",
      subtitle: "De la petite réparation à la rénovation complète – tout d'un seul fournisseur.",
      sanitaer: {
        name: "Sanitaire",
        short: "Installation, entretien & réparation",
        long: "De la réparation de toilettes à l'installation complète de salle de bains. Nous travaillons avec précision, propreté et selon les normes les plus récentes.",
        benefits: ["Réparations rapides", "Installations complètes", "Service d'entretien", "Urgence 24/7"],
        process: ["Conseil & relevé", "Devis transparent", "Exécution ponctuelle", "Contrôle final & garantie"],
      },
      heizung: {
        name: "Service de chauffage",
        short: "Installer, entretenir & optimiser",
        long: "Nouveaux systèmes de chauffage, entretien régulier, optimisations d'efficacité et réparations rapides. Spécialistes en pompes à chaleur, gaz, mazout et pellets.",
        benefits: ["Spécialistes pompes à chaleur", "Conseil en efficacité énergétique", "Entretien & service", "Réparations rapides"],
        process: ["Analyse énergétique", "Choix du système", "Installation professionnelle", "Entretien annuel"],
      },
      sanierung: {
        name: "Rénovation",
        short: "Réparer, moderniser, restaurer",
        long: "Dégâts d'eau, dégâts d'incendie, traitement de moisissures. Rénovation de salles de bains et de cuisines. Nous rénovons moderne et durable.",
        benefits: ["Réparation dégâts d'eau et feu", "Élimination des moisissures", "Rénovation bain & cuisine", "Modernisation électrique/sanitaire"],
        process: ["Analyse des dommages", "Concept de rénovation", "Exécution coordonnée", "Contrôle qualité"],
      },
      umbau: {
        name: "Transformation",
        short: "Repenser vos espaces",
        long: "Cuisines, salles de bains, espaces de vie ou bureaux – nous transformons vos espaces avec des partenaires expérimentés.",
        benefits: ["Transformation complète", "Cuisine & bain", "Bureaux", "Coordination de projet"],
        process: ["Conception & planification", "Permis", "Exécution de tous les corps de métier", "Remise & suivi"],
      },
      ctaQuote: "Demander une consultation gratuite",
      ctaAppointment: "Prendre rendez-vous",
      benefitsTitle: "Vos avantages",
      processTitle: "Notre processus",
      allServicesTitle: "Autres services",
    },
    references: {
      title: "Nos références",
      subtitle: "Une sélection de nos projets réalisés dans la région bâloise.",
      all: "Tous",
      noResults: "Aucune référence dans cette catégorie.",
    },
    about: {
      title: "À propos de SHK Haustechnik GmbH",
      subtitle: "Votre partenaire pour la technique moderne du bâtiment à Allschwil",
      story: "Histoire",
      storyText: "SHK Haustechnik GmbH a été fondée avec une vision claire : offrir des services sanitaires, de chauffage et de ventilation de qualité pour la région bâloise – honnêtes, précis et fiables.",
      values: "Valeurs",
      value1Title: "Qualité",
      value1Text: "Nous ne nous contentons pas de moins que la précision suisse.",
      value2Title: "Fiabilité",
      value2Text: "Nous tenons nos rendez-vous. Et nos promesses. Piquet 24/7 inclus.",
      value3Title: "Satisfaction client",
      value3Text: "Vous n'êtes satisfait que lorsque nous le sommes. Point.",
      team: "Direction",
      founderName: "Elvis Pashaj",
      founderRole: "Directeur & Fondateur",
      founderBio: "Avec de nombreuses années d'expérience dans le domaine SHK, Elvis Pashaj dirige l'entreprise avec passion et les normes de qualité les plus élevées.",
    },
    contact: {
      title: "Contact",
      subtitle: "Nous nous réjouissons de votre demande. Réponse dans les 24 heures.",
      formTitle: "Écrivez-nous",
      firstName: "Prénom",
      lastName: "Nom",
      email: "E-mail",
      phone: "Téléphone",
      service: "Service (optionnel)",
      selectService: "Veuillez choisir",
      message: "Votre message",
      messagePlaceholder: "Décrivez brièvement votre demande…",
      submit: "Envoyer le message",
      submitting: "Envoi…",
      success: "Demande envoyée avec succès !",
      successDetail: "Nous vous répondrons dans les 24 heures.",
      error: "Une erreur s'est produite. Veuillez réessayer.",
      infoTitle: "Informations de contact",
      address: "Adresse",
      addressText: "Weiherweg 14\n4123 Allschwil",
      hours: "Heures d'ouverture",
      hoursText: "Lun–Ven : 07:30 – 17:30\nSam : Sur demande\nPiquet 24/7",
      whatsappCta: "Message WhatsApp",
      callCta: "Appeler maintenant",
    },
    footer: {
      tagline: "Votre technique du bâtiment. Notre passion.",
      quickLinks: "Liens rapides",
      ourServices: "Nos services",
      contactInfo: "Contact",
      newsletter: "Newsletter",
      newsletterText: "Restez informé des offres et conseils.",
      rights: "Tous droits réservés.",
      imprint: "Mentions légales",
      privacy: "Confidentialité",
      pikett: "Service piquet 24/7",
    },
    whatsapp: {
      message: "Bonjour, je suis intéressé par vos services.",
    },
  },
};
